import { BaseModel, NM, RecursivePartial, SM } from "@models/base";
import { VzParamType } from "./param-type";

export class VzParamConstraints extends BaseModel {
    min?: number | string;
    max?: number | string;
    required?: boolean;
    regexp?: string;
    regexpClear?: string;
    readonly?: boolean;
    unique?: string[];      // for Arrays, members must be unique, for Object[] - array of field ids can be specified or ['*'] for all fields
    anyof?: any[];          // if present - only values of this array can be used (enum)

    forbiddenChars?: string;        // TODO ui only, set error if any of string chars present in value

    errors?: { [id: string]: string };

    _regexp?: RegExp;
    _regexpClear?: RegExp;

    constructor(json?: RecursivePartial<VzParamConstraints>) {
        super(json);
        this.parseParamConstraints(json || {});
    }

    parse(json: RecursivePartial<VzParamConstraints>): VzParamConstraints {
        super.parse(json);
        this.parseParamConstraints(json);
        return this;
    }

    private parseParamConstraints(json: RecursivePartial<VzParamConstraints>): void {
        VzParamConstraints.assignFields<VzParamConstraints>(this, json, [
            'min',
            'max',
            'required',
            'errors',
            'regexp',
            'regexpClear',
            'unique',
            'anyof',
            'readonly',
            'forbiddenChars',
        ]);
        if (this.anyof && !Array.isArray(this.anyof)) {
            this.anyof = undefined;
        }
        if (this.regexp) {
            try {
                this._regexp = new RegExp(this.regexp);
            }
            catch(_) {}
        }
        if (this.regexpClear) {
            try {
                this._regexpClear = new RegExp(this.regexpClear, 'g');
            }
            catch(_) {}
        }
    }
}

export const DEFAULT_CONSTRAINTS_ERRORS: NM<SM<string>> = {
    0: {
        required: 'Обязательный параметр',
        min: 'Значение меньше допустимого',
        max: 'Значение больше допустимого',
        regexp: 'Некорректный формат значения',
        unique: 'Такое значение уже задано',
        anyof: 'Недопустимое значение',
        forbiddenChars: 'Использован недопустимый символ',
    },
    [VzParamType.String]: {
        min: 'Строка слишком короткая',
        max: 'Строка слишком длинная',
    }
}

export const DEFAULT_CONSTRAINT_ERROR = 'Ошибка заполнения';
